import React from 'react';
import './Overlays.css';
import { trackEPassPageEvent } from '../../utils/omnitureTracking';
type EpassNotRequiredOverlayProps = {
  handleNotRequired: () => void;
  redirectToCabsPage: (cabsListingUrl?: string) => void;
  cabsFound: boolean;
};
const EpassNotRequiredOverlay = ({
  handleNotRequired,
  redirectToCabsPage,
  cabsFound
}: EpassNotRequiredOverlayProps) => {
  const onBookNowClick = () => {
    trackEPassPageEvent(
      cabsFound
        ? 'Cab_SEO_Epass_Mysafety_Popup_Booknow_Click'
        : 'Cab_SEO_Epass_NoCabs_Popup_ViewCabs_Click'
    );
    redirectToCabsPage();
  };
  return (
    <div className="epass__overlay makeFlex column">
      <span
        className="epass__overlay__close"
        onClick={handleNotRequired}
      ></span>
      <p
        className={` latoBlack dark__text ${
          cabsFound ? 'epass__form__title' : 'epass__form__title22'
        }`}
      >
        {cabsFound
          ? `e-Pass is not required on your route`
          : `Sorry, we don't currently serve on your route`}
      </p>
      <p className="epass__form__subtitle">
        {cabsFound
          ? `Book a sanitized cab now for your journey!`
          : `You can explore our cabs on other routes!`}
      </p>
      <p className="safty__text latoBlack">
        <span className="epass__sprite safty__icon appendRight10"></span>
        <span className="blueText">My</span>Safety - Book Hygienic Cabs
      </p>
      <ul className="safty__list">
        <li>
          <span className="safty__icon__wrap">
            <span className="drivermask__icon epass__sprite"></span>
          </span>{' '}
          Driver with Masks
        </li>
        <li>
          <span className="safty__icon__wrap">
            <span className="sanitizedcab__icon epass__sprite"></span>
          </span>{' '}
          Sanitized Cabs
        </li>
        <li>
          <span className="safty__icon__wrap">
            <span className="aarogyasetu__icon epass__sprite"></span>
          </span>{' '}
          Drivers with Aarogya Setu app
        </li>
        <li>
          <span className="safty__icon__wrap">
            <span className="handsanitizers__icon epass__sprite"></span>
          </span>{' '}
          Hand Sanitizers
        </li>
      </ul>
      <button className="epass__form__btn" onClick={onBookNowClick}>
        {cabsFound ? 'Book Now' : 'VIEW CABS'}
      </button>
    </div>
  );
};

export default EpassNotRequiredOverlay;
